module.exports = __webpack_public_path__ + "static/media/sub_comment.f7ac8f06.svg";